import React from "react";

// importing components to use on football schedule routed page
import FootballSchedulePage from "../components/Football/FootballSchedule";

export default function FootballSchedle() {
  return (
    <div className="football-section pt-5 pb-5 d-flex align-items-center flex-column">
      <FootballSchedulePage />
    </div>
  );
}
